// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OdobrenjeKomentar_infoModal__j395G {
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 24px 0px 24px 0px;
  justify-content: space-between;
}
.OdobrenjeKomentar_modalWrapper__UnSSF {
  justify-content: flex-start;
  flex-direction: column;
  width: 97%;
  box-shadow: 0px 1px 2px 0px #1018280d;
  padding: 0 20px;
}
.OdobrenjeKomentar_infoModal__j395G,
.OdobrenjeKomentar_modalWrapper__UnSSF,
.OdobrenjeKomentar_btnRow__cj89L,
.OdobrenjeKomentar_modalOverlay__rKxI5,
.OdobrenjeKomentar_textareaWrapper__-BH2B {
  display: flex;
  align-items: center;
}
.OdobrenjeKomentar_textareaWrapper__-BH2B {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.OdobrenjeKomentar_exitBtn__t-7hO {
  position: absolute;
  top: 5%;
  right: 3%;
  cursor: pointer;
}
.OdobrenjeKomentar_title__Ou6n5,
.OdobrenjeKomentar_subtitle__nGxAZ {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.OdobrenjeKomentar_title__Ou6n5 {
  font-size: 28px;
  line-height: 34px;
  margin-block-end: 0px;
}
.OdobrenjeKomentar_subtitle__nGxAZ {
  font-size: 20px;
  line-height: 22px;
  margin-bottom: 50px;
}
.OdobrenjeKomentar_inputWrapper__zDsIw {
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  justify-content: center;
}
.OdobrenjeKomentar_label__ryIJp {
  text-align: left;
  color: #828d9a;
  margin-bottom: 20px;
}
.OdobrenjeKomentar_btnRow__cj89L {
  justify-content: center;
  gap: 24px;
  width: 100%;
  padding-right: 48px;
  margin-top: 30px;
}
.OdobrenjeKomentar_cancelBtn__a2P8Z,
.OdobrenjeKomentar_successBtn__ppN7n,
.OdobrenjeKomentar_TrueBtn__HREb3,
.OdobrenjeKomentar_FalseBtn__YySZG {
  width: 40%;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
}
.OdobrenjeKomentar_cancelBtn__a2P8Z,
.OdobrenjeKomentar_successBtn__ppN7n,
.OdobrenjeKomentar_label__ryIJp,
.OdobrenjeKomentar_TrueBtn__HREb3,
.OdobrenjeKomentar_FalseBtn__YySZG {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.OdobrenjeKomentar_successBtn__ppN7n {
  background: #cb9c2d;
  color: #fff;
}
.OdobrenjeKomentar_successBtn__ppN7n:hover {
  background-color: #9b7725;
}
.OdobrenjeKomentar_TrueBtn__HREb3,
.OdobrenjeKomentar_FalseBtn__YySZG {
  opacity: 0.7;
  pointer-events: none;
  cursor: not-allowed;
  color: #ffffff;
}
.OdobrenjeKomentar_allowClick__VI1Dx {
  pointer-events: auto !important;
  cursor: pointer;
  opacity: 1;
}

.OdobrenjeKomentar_FalseBtn__YySZG {
  background-color: #ac2626;
}
.OdobrenjeKomentar_TrueBtn__HREb3 {
  background: #cb9c2d;
}
.OdobrenjeKomentar_cancelBtn__a2P8Z {
  background-color: #ebebeb;
  color: #808080;
}
.OdobrenjeKomentar_cancelBtn__a2P8Z:hover {
  background-color: #a09f9f;
  color: #fff;
}
.OdobrenjeKomentar_input__BvLNW {
  width: 100%;
  resize: none;
  padding: 14px 8px 14px 8px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  text-align: left;
  color: #5f6d7e;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
  height: 80px;
}

@media screen and (max-width: 1300px) {
  .OdobrenjeKomentar_modalOverlay__rKxI5 {
    width: 100%;
    left: 0;
  }
}

@media screen and (max-width: 1030px) {
  .OdobrenjeKomentar_btnRow__cj89L {
    justify-content: center;
    padding: 0;
  }
  .OdobrenjeKomentar_successBtn__ppN7n,
  .OdobrenjeKomentar_cancelBtn__a2P8Z {
    width: 40%;
  }
}

@media screen and (max-width: 850px) {
  .OdobrenjeKomentar_modalWrapper__UnSSF {
    position: inherit;
    bottom: 0;
    width: 95%;
    border-radius: 16px 16px 0px 0px;
  }
  .OdobrenjeKomentar_input__BvLNW {
    height: 200px;
    box-sizing: border-box;
  }
  .OdobrenjeKomentar_title__Ou6n5,
  .OdobrenjeKomentar_subtitle__nGxAZ {
    text-align: center;
  }
}

@media screen and (max-width: 410px) {
  .OdobrenjeKomentar_successBtn__ppN7n,
  .OdobrenjeKomentar_cancelBtn__a2P8Z {
    width: 43%;
    padding: 8px 14px;
  }
  .OdobrenjeKomentar_btnRow__cj89L {
    gap: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/documents/components/OdobrenjeAplikacija/PostKomentar/OdobrenjeKomentar.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;EACV,qCAAqC;EACrC,eAAe;AACjB;AACA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;AACF","sourcesContent":[".infoModal {\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding: 24px 0px 24px 0px;\n  justify-content: space-between;\n}\n.modalWrapper {\n  justify-content: flex-start;\n  flex-direction: column;\n  width: 97%;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  padding: 0 20px;\n}\n.infoModal,\n.modalWrapper,\n.btnRow,\n.modalOverlay,\n.textareaWrapper {\n  display: flex;\n  align-items: center;\n}\n.textareaWrapper {\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.exitBtn {\n  position: absolute;\n  top: 5%;\n  right: 3%;\n  cursor: pointer;\n}\n.title,\n.subtitle {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.title {\n  font-size: 28px;\n  line-height: 34px;\n  margin-block-end: 0px;\n}\n.subtitle {\n  font-size: 20px;\n  line-height: 22px;\n  margin-bottom: 50px;\n}\n.inputWrapper {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 64px;\n  justify-content: center;\n}\n.label {\n  text-align: left;\n  color: #828d9a;\n  margin-bottom: 20px;\n}\n.btnRow {\n  justify-content: center;\n  gap: 24px;\n  width: 100%;\n  padding-right: 48px;\n  margin-top: 30px;\n}\n.cancelBtn,\n.successBtn,\n.TrueBtn,\n.FalseBtn {\n  width: 40%;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n}\n.cancelBtn,\n.successBtn,\n.label,\n.TrueBtn,\n.FalseBtn {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.successBtn {\n  background: #cb9c2d;\n  color: #fff;\n}\n.successBtn:hover {\n  background-color: #9b7725;\n}\n.TrueBtn,\n.FalseBtn {\n  opacity: 0.7;\n  pointer-events: none;\n  cursor: not-allowed;\n  color: #ffffff;\n}\n.allowClick {\n  pointer-events: auto !important;\n  cursor: pointer;\n  opacity: 1;\n}\n\n.FalseBtn {\n  background-color: #ac2626;\n}\n.TrueBtn {\n  background: #cb9c2d;\n}\n.cancelBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.cancelBtn:hover {\n  background-color: #a09f9f;\n  color: #fff;\n}\n.input {\n  width: 100%;\n  resize: none;\n  padding: 14px 8px 14px 8px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  text-align: left;\n  color: #5f6d7e;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n  height: 80px;\n}\n\n@media screen and (max-width: 1300px) {\n  .modalOverlay {\n    width: 100%;\n    left: 0;\n  }\n}\n\n@media screen and (max-width: 1030px) {\n  .btnRow {\n    justify-content: center;\n    padding: 0;\n  }\n  .successBtn,\n  .cancelBtn {\n    width: 40%;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .modalWrapper {\n    position: inherit;\n    bottom: 0;\n    width: 95%;\n    border-radius: 16px 16px 0px 0px;\n  }\n  .input {\n    height: 200px;\n    box-sizing: border-box;\n  }\n  .title,\n  .subtitle {\n    text-align: center;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  .successBtn,\n  .cancelBtn {\n    width: 43%;\n    padding: 8px 14px;\n  }\n  .btnRow {\n    gap: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoModal": `OdobrenjeKomentar_infoModal__j395G`,
	"modalWrapper": `OdobrenjeKomentar_modalWrapper__UnSSF`,
	"btnRow": `OdobrenjeKomentar_btnRow__cj89L`,
	"modalOverlay": `OdobrenjeKomentar_modalOverlay__rKxI5`,
	"textareaWrapper": `OdobrenjeKomentar_textareaWrapper__-BH2B`,
	"exitBtn": `OdobrenjeKomentar_exitBtn__t-7hO`,
	"title": `OdobrenjeKomentar_title__Ou6n5`,
	"subtitle": `OdobrenjeKomentar_subtitle__nGxAZ`,
	"inputWrapper": `OdobrenjeKomentar_inputWrapper__zDsIw`,
	"label": `OdobrenjeKomentar_label__ryIJp`,
	"cancelBtn": `OdobrenjeKomentar_cancelBtn__a2P8Z`,
	"successBtn": `OdobrenjeKomentar_successBtn__ppN7n`,
	"TrueBtn": `OdobrenjeKomentar_TrueBtn__HREb3`,
	"FalseBtn": `OdobrenjeKomentar_FalseBtn__YySZG`,
	"allowClick": `OdobrenjeKomentar_allowClick__VI1Dx`,
	"input": `OdobrenjeKomentar_input__BvLNW`
};
export default ___CSS_LOADER_EXPORT___;
